import React from 'react';
import { observer } from 'mobx-react-lite';
import BlockHeader from 'pages/components/blockHeader';
import SecondaryButton from 'shared/lib/components/controls/buttons/secondaryButton';
import ButtonsContainer from 'shared/lib/components/controls/buttons/buttonsContainer';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';
import { useTranslation } from 'react-i18next';

export default observer(function TrashPageHeader({
  text,
  restoreText,
  clearText,
  onRestore,
  onClear,
}: {
  text?: string;
  restoreText?: string;
  clearText?: string;
  onRestore: () => void;
  onClear: () => void;
}) {
  const { t } = useTranslation();
  text = text || t('common.trash');
  restoreText = restoreText || t('actions.restoreAll');
  clearText = clearText || t('trash.clearTrash');

  return (
    <BlockHeader
      // Почему то компилятор TS в этом месте выдает кринж без as
      text={text as string}
      buttonsNode={
        <PrimaryButton sx={{ width: 0.5 }} onClick={onClear}>
          {clearText}
        </PrimaryButton>
      }
    ></BlockHeader>
  );
});
